import React from 'react';
import SvgColor from '../../components/svg-color';

// @ts-ignore
const icon = (name: string) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const NavConfig = (t: (key: string) => string) => {

  return [
    {
      title: t('categories.categories'),
      path: '/dashboard/categories',
      icon: icon('list-circle'),
    },
    {
      title: t('content.content'),
      path: '/dashboard/nltdevskeletons',
      icon: icon('newspaper'),
    }, 
    {
      title: t('notifications.notifications'),
      path: '/dashboard/notifications',
      icon: icon('ic_round-circle-notifications'),
    }, 
    {
      title: t('banner.banner'),
      path: '/dashboard/banners',
      icon: icon('settings-fill'),
    }, 
    {
      title: t('subscriptions.subscriptions'),
      path: '/dashboard/product',
      icon: icon('ic_notification_chat'), 
    },
    {
      title: t("menstrualCycles.menstrualCycles"),
      path: '/dashboard/menstrual-phases',
      icon: icon('clock'),
    },
    {
      title: t("magazineCategory.magazineCategories"),
      path: '/dashboard/magazine-categories',
      icon: icon('options'),
    },
    {
      title: t("force_update.force_update"),
      path: '/dashboard/force-update',
      icon: icon('update'),
    },
  ];
};

export default NavConfig;
